import * as actionTypes from "./actionTypes";

const initialState = {};

const createBotReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.firstBotCreateActionType:
    
      return {
        ...state,
        ...action.payload
      };
    default:
      return initialState;
  }
};

export default createBotReducer;
